import { Component, OnInit } from '@angular/core';
import { PreloaderService } from '../core/components/preloader/preloader.service';
import { ActivatedRoute } from '@angular/router';
import { AuthService } from '../auth/auth.service';
import { EnvironmentService } from '../core/services';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-authorization',
  templateUrl: './authorization.component.html'
})
export class AuthorizationComponent implements OnInit {

  public message: string;
  private allowedMessageList: Array<string>;
  private logoutCaseList: Array<string>;
  public showContactDetails: boolean;
  public emailContact: string;
  public contactDetails: string;

  constructor(
    private preloaderService: PreloaderService,
    private authService: AuthService,
    private envService: EnvironmentService,
    private translateService: TranslateService,
    private route: ActivatedRoute
  ) {
    this.allowedMessageList = ['UNAUTHORIZED', 'NOSTORE', 'NODETAILS', 'NOCONTENT', 'SESSIONEXPIRED'];
    this.logoutCaseList = ['NOSTORE', 'SESSIONEXPIRED'];
    this.showContactDetails = false;
    this.contactDetails = '';
  }

  ngOnInit() {

    this.route.params.subscribe((params: any) => {
      this.message = params.message.toLocaleUpperCase();
      if (!this.allowedMessageList.includes(this.message)) {
        this.message = 'NOCONTENT';
      }

      if (this.message === 'NOSTORE') {
        this.emailContact = this.envService.getStore('supportTeamEmail');
        this.translateService.get('HOME.AUTHORIZATION.MESSAGE.CONTACT',
        {teamEmail: this.emailContact}).subscribe(
          (text) => {
            this.contactDetails = text;
          }
        );
        this.showContactDetails = true;
      }
      if (this.logoutCaseList.includes(this.message)) {
        const that = this;
        setTimeout(
          function() {
            that.authService.logout();
          }, 5000);
      }
    });
    this.preloaderService.hidePreLoader();
  }

}



// WEBPACK FOOTER //
// C:/Users/sthanga1/Documents/apicloud-x/apicloud-x/apim-ui-newgen/src/app/authorization/authorization.component.ts